import { CircularProgress, Stack, Typography, useTheme } from "@mui/material";
import { Navigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AdvisorRestrictionBanner } from "web_myplann/More/NotificationSettings/Components/AdvisorRestrictionBanner";
import { ContractsSection } from "web_myplann/More/NotificationSettings/Components/ContractsSection";
import { useNotificationSettingsAccess } from "web_myplann/More/NotificationSettings/Hooks/useNotificationSettingsAccess";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const NotificationSettingsPage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { isLoading, isError, isPageAccessible, isBannerVisible } =
		useNotificationSettingsAccess();

	if (!isLoading && !isError && !isPageAccessible) {
		return <Navigate to={Routing.Profile.More.path()} replace />;
	}

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[100]}
			topBar={
				<NavigationHeader
					title={t(Resources.Settings.NotificationSettings.title)}
					defaultRoute={Routing.Profile.More.path()}
				/>
			}
		>
			<Stack sx={{ minHeight: "100%" }}>
				{isLoading ? (
					<Stack alignItems="center" justifyContent="center" py={4}>
						<CircularProgress size={24} />
					</Stack>
				) : isError ? (
					<Stack alignItems="center" justifyContent="center" py={4} px={1.6}>
						<Typography
							variant="body1"
							color={theme.palette.grey[700]}
							textAlign="center"
						>
							{t(Resources.Settings.NotificationSettings.LoadingError)}
						</Typography>
					</Stack>
				) : (
					<>
						{isBannerVisible && <AdvisorRestrictionBanner />}
						<ContractsSection />
					</>
				)}
			</Stack>
		</MyPlannLayout>
	);
};
